import apiService from "../../api/api.service";
import { RecentlyViewedResponse, GetRecentlyViewedRequest } from "./recently-viewed.types";

/**
 * Get customer's recently viewed products
 */
export const fetchRecentlyViewedProducts = (params?: GetRecentlyViewedRequest) => {
  return apiService.get<RecentlyViewedResponse>("/customers/recently-viewed", { params });
};